import { defineModule } from '@kubdee/sdk'
import { MODULES } from '@kubdee/shared'
import { migrations } from './migrations'
import { hrDoctypes } from './doctypes'

// 🔄 To change icon, also add the new icon to apps/web/src/lib/icon-registry.ts
const MODULE_ICON = 'Users'
const MODULE_COLOR = '#2490EF'

export default defineModule({
  name: MODULES.HR,
  label: 'บุคคล',
  icon: MODULE_ICON,
  color: MODULE_COLOR,
  version: '1.0.0',
  dependencies: [MODULES.CORE],
  category: 'hr',
  isSystemModule: false,

  schemas: {},
  routes: {},
  navigation: {
    label: 'บุคคล',
    icon: MODULE_ICON,
    groups: [
      {
        label: 'ภาพรวม',
        items: [
          { label: 'แดชบอร์ด', path: '/hr/dashboard', icon: 'LayoutDashboard' },
        ],
      },
      {
        label: 'ข้อมูลหลัก',
        items: [
          { label: 'พนักงาน', path: '/hr/employees', icon: 'Users' },
          { label: 'แผนก', path: '/hr/departments', icon: 'Building2' },
          { label: 'ตำแหน่ง', path: '/hr/designations', icon: 'Contact' },
        ],
      },
      {
        label: 'เงินเดือน',
        items: [
          { label: 'สลิปเงินเดือน', path: '/hr/salary-slips', icon: 'Wallet' },
          { label: 'การจ่ายเงินเดือน', path: '/hr/payroll-entries', icon: 'Wallet' },
          { label: 'โครงสร้างเงินเดือน', path: '/hr/salary-structures', icon: 'Wallet' },
        ],
      },
      {
        label: 'วันลา',
        items: [
          { label: 'ใบลา', path: '/hr/leave-applications', icon: 'CalendarDays' },
          { label: 'สิทธิ์วันลา', path: '/hr/leave-allocations', icon: 'CalendarDays' },
          { label: 'ประเภทวันลา', path: '/hr/leave-types', icon: 'CalendarDays' },
        ],
      },
      {
        label: 'เวลาทำงาน',
        items: [
          { label: 'บันทึกเวลา', path: '/hr/attendance', icon: 'Clock' },
          { label: 'ขอล่วงเวลา', path: '/hr/overtime-requests', icon: 'Clock' },
        ],
      },
      {
        label: 'รายงาน',
        items: [
          { label: 'ภ.ง.ด.1', path: '/hr/reports/pnd1', icon: 'FileSpreadsheet' },
          { label: 'สปส.1-10', path: '/hr/reports/sps1-10', icon: 'FileSpreadsheet' },
          { label: '50 ทวิ', path: '/hr/reports/withholding-tax', icon: 'FileSpreadsheet' },
        ],
      },
    ],
  },
  permissions: {},
  hooks: {},

  doctypes: [
    { key: "employees", label: "พนักงาน" },
    { key: "departments", label: "แผนก" },
    { key: "designations", label: "ตำแหน่ง" },
    { key: "leave-types", label: "ประเภทวันลา" },
    { key: "leave-applications", label: "ใบลา", type: "submittable" },
    { key: "leave-allocations", label: "สิทธิ์วันลา" },
    { key: "holidays", label: "วันหยุด" },
    { key: "salary-structures", label: "โครงสร้างเงินเดือน" },
    { key: "salary-components", label: "รายการเงินเดือน" },
    { key: "payroll-entries", label: "การจ่ายเงินเดือน", type: "submittable" },
    { key: "salary-slips", label: "สลิปเงินเดือน", type: "submittable" },
    { key: "attendance", label: "บันทึกเวลา" },
    { key: "overtime-requests", label: "ขอล่วงเวลา", type: "submittable" },
  ],
  availableHooks: [
    { event: "hr.employee.created", label: "สร้างพนักงานใหม่" },
    { event: "hr.payroll.submitted", label: "ยืนยันการจ่ายเงินเดือน" },
    { event: "hr.leave.approved", label: "อนุมัติใบลา" },
  ],

  fixtures: [],

  moduleMigrations: migrations,

  // Doctype Admin Epic (#347) issue #423. See `./doctypes.ts` — the
  // platform boot loop in `apps/tenant-worker/src/middleware/auto-migrate.ts`
  // reads this field from every enabled module's manifest and upserts the
  // platform-default rows into `core_doctype_registry` +
  // `core_numbering_series` (with `company_id = NULL`).
  registeredDoctypes: hrDoctypes,
})
